import React from "react";
import { useState, useEffect, useRef } from "react";
import useScrollAnimation from "../../hooks/UseScrollAnimation";
export default function Statitics() {
    const [started, setStarted] = useState(false);
    const [counts, setCounts] = useState([0, 0, 0, 0]);
    const countersRef = useRef([]);
    useScrollAnimation();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const goals = [60, 100, 50, 80];
    const labels = ["Clients", "Projects", "Partners", "Achievements"];


    useEffect(() => {
        const handleScroll = () => {
            if (!started && window.scrollY >= countersRef.current[0].offsetTop - 400) {
                setStarted(true);
                startCount();
            }
        };

        const startCount = () => {
            goals.forEach((goal, index) => {
                const interval = setInterval(() => {
                    setCounts((prevCounts) => {
                        const newCounts = [...prevCounts];
                        if (newCounts[index] < goal) {
                            newCounts[index] = newCounts[index] + 1;
                        } else {
                            clearInterval(interval);
                        }
                        return newCounts;
                    });
                }, 3000 / goal);
            });
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, [goals, started]);
    return (
        <div className="f-col js-scroll fade-btm flex items-center justify-between gap-[15px]">
            {counts.map((count, index) => (
                <div
                    key={index}
                    ref={(el) => countersRef.current[index] = el}
                    className="w-[275px] h-[180px] text-center bg-[#5EBDBA] rounded-[8px] flex flex-col items-center justify-center text-white"
                >
                    <div className="text-[40px] font-bold">{count} +</div>
                    <div className="font-bold text-white text-[25px]">{labels[index]}</div>
                </div>
            ))}
        </div>
    );
}